// extracted by mini-css-extract-plugin
export default {"item":"item_UvCXpqpW","icon":"icon_WPZ08XcW"};